import React, { useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const assessmentContex = createContext();

export const AssessmentProvider = ({ children }) => {
  const [selectedCourseId, setSelectedCourseId] = useState(-1);
  const [selectedStatusIds, setSelectedStatusIds] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [filters, setFilters] = useState(null);
  const [isSearch, setIsSearch] = useState(false);
  const [isAssessmentAvailable, setIsAssessmentAvailable] = useState(true);
  const [selectedAssesmentStatus, setSelectedAssesmentStatus] = useState([]);
  const [selectedAssessments, setSelectedAssessments] = useState(null);
  const [assessmentId, setAssessmentId] = useState(null);
  const [assessmentName, setAssessmentName] = useState('');
  const [refreshAssessments, setRefreshAssessments] = useState(new Date().getSeconds());

  return (
    <assessmentContex.Provider
      value={{
        setSelectedCourseId,
        selectedCourseId,
        selectedStatusIds,
        setSelectedStatusIds,
        searchText,
        setSearchText,
        filters,
        setFilters,
        isSearch,
        setIsSearch,
        isAssessmentAvailable,
        setIsAssessmentAvailable,
        selectedAssesmentStatus,
        setSelectedAssesmentStatus,
        selectedAssessments,
        setSelectedAssessments,
        assessmentId,
        setAssessmentId,
        assessmentName,
        setAssessmentName,
        refreshAssessments,
        setRefreshAssessments
      }}>
      {children}
    </assessmentContex.Provider>
  );
};

AssessmentProvider.propTypes = {
  children: PropTypes.node
};

export const useAssessmentContext = () => useContext(assessmentContex);
